import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, InputError, Select } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { emptyError, useUpdateIncluded } from "../../../utils/commonUtils";
import {
  BANKING,
  FEEDBACK_SUBJECTS,
  INSURANCE,
  SUBJECT_KEY,
} from "../../../utils/enums";
import withAnimation from "../../../utils/withAnimation";

const FeedbackSubject = observer(({ FeedbackStore }) => {
  const key = SUBJECT_KEY;
  const {
    feedback,
    updateError,
    updateValue,
    updateIncluded,
    updateTopic,
    displayFeedbackSubject,
    isInsuranceFeedback,
  } = FeedbackStore;
  const subject = feedback.subject;
  const msgs = useMessageGetter("feedback.form.subject");
  const options = FEEDBACK_SUBJECTS[isInsuranceFeedback ? INSURANCE : BANKING];

  // Update included property when feedback target value changes
  useUpdateIncluded(key, displayFeedbackSubject, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
    updateTopic(value, msgs);
  };

  const handleOnBlur = () => {
    if (!subject.value) updateError(key, emptyError(msgs));
  };

  return (
    <div className="cff-feedbackSubject">
      <FormRow
        label={msgs("label")}
        labelFor={`CFF-${key}`}
        labelId={`cff-feedbackSubject`}
      >
        <Select
          id={`CFF-${key}`}
          name={key}
          value={subject.value}
          onChange={(e) => handleOnChange(e.target.value)}
          onBlur={handleOnBlur}
          invalid={!!subject.error}
          aria-describedby={!!subject.error ? `CFF-${key}-error` : null}
          aria-required={true}
        >
          <option value="">{msgs("option.default")}</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {msgs(`option.${option}`)}
            </option>
          ))}
        </Select>
        <InputError
          error={subject.error ? subject.error : null}
          id={`CFF-${key}-error`}
        />
      </FormRow>
    </div>
  );
});

export default withAnimation(inject("FeedbackStore")(FeedbackSubject));
export const FeedbackSubjectNoAnimation =
  inject("FeedbackStore")(FeedbackSubject);
